var map = {
	"./Deputi Bidang Pencegahan_0003.jpg": 98316,
	"./Deputi Bidang Pencegahan_0004.jpg": 48945,
	"./Deputi Bidang Pencegahan_0005.jpg": 42068,
	"./Deputi Bidang Pencegahan_0006.jpg": 73797,
	"./Deputi Bidang Pencegahan_0007.jpg": 60974,
	"./Deputi Bidang Pencegahan_0008.jpg": 28988,
	"./Deputi Bidang Pencegahan_0009.jpg": 24609,
	"./Deputi Bidang Pencegahan_0010.jpg": 47384,
	"./Deputi Bidang Pencegahan_0011.jpg": 20677,
	"./Deputi Bidang Pencegahan_0012.jpg": 49532,
	"./Deputi Bidang Pencegahan_0013.jpg": 494,
	"./Deputi Bidang Pencegahan_0014.jpg": 49245,
	"./Deputi Bidang Pencegahan_0015.jpg": 52664,
	"./Deputi Bidang Pencegahan_0016.jpg": 72344,
	"./Deputi Bidang Pencegahan_0017.jpg": 44946,
	"./Deputi Bidang Pencegahan_0018.jpg": 2944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74879;